export const VIDEO_DETAILS_DATE_FORMAT = 'MM/dd/yyyy'
